// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const SettlementNoRegistration = t.struct({
    branch: t.maybe(t.String),
    days: t.maybe(t.Number),
    division: t.maybe(t.String),
    invoiceDate: t.maybe(t.Number),
    invoiceDealer: t.maybe(t.String),
    invoiceDealerName: t.maybe(t.String),
    invoiceNumber: t.maybe(t.String),
    pin: t.maybe(t.String),
    responsibleDealer: t.maybe(t.String),
    responsibleDealerName: t.maybe(t.String),
    settlementDate: t.maybe(t.Number)
}, {
    name: 'SettlementNoRegistration',
    strict: true
});

export const getDefaultState = () => new SettlementNoRegistration({});

export default SettlementNoRegistration;




// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/settlement-no-registration.js